import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const activityTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Auth version constant - must match across the application
export const AUTH_VERSION = '2.0.0';

export const TokenManager = {
  /**
   * Store authentication tokens in localStorage
   */
  storeTokens: (token: string, expires: string, time_zone: string) => {
    localStorage.setItem("apiToken", token);
    localStorage.setItem("apiTokenExpires", expires);
    localStorage.setItem(
      "lastSignIn",
      dayjs().tz(time_zone || activityTimeZone).format()
    );
    // Set auth version when storing tokens
    localStorage.setItem("authVersion", AUTH_VERSION);
  },

  /**
   * Check if token exists in localStorage
   */
  hasStoredToken: (): boolean => {
    return !!localStorage.getItem("apiToken");
  },

  /**
   * Get stored token from localStorage
   */
  getToken: (): string | null => {
    return localStorage.getItem("apiToken");
  },

  /**
   * Get token expiry from localStorage
   */
  getTokenExpiry: (): string | null => {
    return localStorage.getItem("apiTokenExpires");
  },

  /**
   * Clear all tokens from localStorage
   */
  clearTokens: () => {
    localStorage.removeItem("apiToken");
    localStorage.removeItem("apiTokenExpires");
    localStorage.removeItem("lastSignIn");
  }
};